import React from "react";
import FishDataGraphView from "../graphView/FishDataGraphView";
import GraphChartV2 from "./GraphChartV2";

/**
 * New Graph View entry point.
 * Keeps full parity by reusing the current production graph view
 * while we migrate chart internals incrementally in graphViewV2.
 */
export default function FishDataGraphViewV2() {
  return <FishDataGraphView GraphChartComponent={GraphChartV2} />;
}
